import { Controller } from "@hotwired/stimulus";
import debounce from 'lodash.debounce'

export default class extends Controller {
  static values = {
    previewUrl: String,
    turboFrameId: String
  };

  connect() {
    this.update = debounce(this.update, 500);
    this.update()
  }

  update() {
    const form = this.element.cloneNode(true);
    const methodField = form.querySelector('input[name="_method"]');
    if (methodField) methodField.value = "post";

    const originalSelects = Array.from(this.element.querySelectorAll("select"));
    const clonedSelects = Array.from(form.querySelectorAll("select"));

    // Copy selected options from original select to cloned select, for some reason they don't get copied
    originalSelects.forEach((select, index) => {
      Array.from(clonedSelects[index].options).forEach((option, optIndex) => {
        option.selected = select.options[optIndex].selected;
      });
    });

    form.action = this.previewUrlValue;
    form.dataset.turboFrame = this.turboFrameIdValue;

    form.classList.add("hidden");
    document.body.appendChild(form);
    form.requestSubmit();
    form.remove();
  }
}
